import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-practice-message-box',
  templateUrl: './case-practice-messagebox.component.html',
  styleUrls: ['./case-practice-messagebox.component.css']
})
export class CasePracticeMessageboxComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/case-practice-hotel-component/case-practice-messagebox.component.ts